import clsx from 'clsx';
import React from 'react';

import Text from '@Components/design-system/text-v2';
import { whatsappContactLink } from '@Utils/constants';

import { TextPalette } from '../color-v2/types';
import Icon from '../icon';
import { FontType } from '../text-v2/types';

// Layout constants
const LAYOUT = {
  container: 'fixed right-4 flex flex-col items-center transition-all duration-1000 ease-in-out',
  button:
    'flex items-center justify-center px-4 py-3 rounded-2xl transition-all duration-1000 ease-in-out h-12 overflow-hidden',
  textWrapper: 'whitespace-nowrap transition-all duration-1000 ease-in-out',
  buttonShadow: '0px 0px 8px rgba(0, 0, 0, 0.25)',
};

interface Props {
  visibility: boolean;
  position?: number;
  text?: string;
  iconName?: string;
  iconSrc?: 'google' | 'internal';
  backgroundColor?: string;
  textColor?: TextPalette;
  onClick?: () => void;
}

const BottomNavbarWhatsAppIcon: React.FC<Props> = ({
  visibility,
  position = 88,
  text = 'Chat with us',
  iconName = 'assets/svgs/social.svg',
  iconSrc = 'internal',
  backgroundColor = 'bg-palette-SUCCESS_700',
  textColor = TextPalette.LIGHT_1,
  onClick = () => window.open(whatsappContactLink),
}) => {
  return (
    <div style={{ bottom: position }} className={clsx(LAYOUT.container, visibility ? 'w-auto' : 'w-12')}>
      <button
        style={{
          boxShadow: LAYOUT.buttonShadow,
        }}
        className={clsx(LAYOUT.button, backgroundColor, 'text-white', visibility ? 'w-auto' : 'w-12')}
        onClick={onClick}>
        <span className={clsx(LAYOUT.textWrapper, visibility ? 'mr-2 opacity-100 max-w-[100px]' : 'opacity-0 max-w-0')}>
          <Text type='span' font={FontType.BODY_B} color={textColor}>
            {text}
          </Text>
        </span>
        <Icon size={'s'} name={iconName} src={iconSrc} />
      </button>
    </div>
  );
};

export default BottomNavbarWhatsAppIcon;
